<template>
  <div class="frontCommon">
    <commonBanner
      :bgImg="bgImg"
      :search="true"
      @search="handleSearch"
      :keywords="keywords"
    ></commonBanner>
    <div class="talent-body-wrap home-mini-width hom-max-width">
      <div class="TitleCard-all">
        <TitleCard title="全部" :showMore="false"></TitleCard>
      </div>
      <div class="switch-wrap">
        <div class="resultList" v-if="list.length > 0">
          <div
            class="result-wrap"
            v-for="item in list.slice((pageNum -1) * pageSize, pageSize*pageNum )"
            :key="item.id"
            @click="toDetail(item)"
          >
            <div class="result-title">
              {{ item.title || item.name }}
            </div>
            <div class="result-infomation">
              <div>{{ item.type }}</div>
              <div>发布时间：{{ item.publishTime }}</div>
            </div>
          </div>
          <Pagination
            :total="total"
            @change="change"
            ref="pagination"
          ></Pagination>
        </div>
        <Empty v-else></Empty>
      </div>
    </div>
    <VideoPlay
      ref="video"
      :videoUrl="url"
      @cancelPlay="cancelPlay"
      :loading="loadingVideo"
    ></VideoPlay>
  </div>
</template>
<script>
import Pagination from '@/views/IndustryInformation/pages/components/pagination'
import commonBanner from '@/components/common/banner'
import { getSearchResult } from '@/api/searchResult'
import Empty from '@/components/common/Empty';
import { getVideoInfoDetail, viewsVideInfo } from '@/api/MTrainVideo.js'
const timeStandrd = require('@/utils/moment')
import VideoPlay from '@/components/videoplayer/videoplayer'

export default {
  data() {
    return {
      bgImg: require('@/assets/images/查询结果banner.png'),
      list: [],
      total: 100,
      keywords: '',
      searchValue: '',
      loadingVideo: false, // 加载视频
      url: '',
      pageSize: 10,
      pageNum: 1 
    }
  },
  watch: {
    $route: {
      handler(nVal) {
        //取默认的值，首页搜索也是默认搜索行业资讯
        const { keywords } = nVal.query
        this.keywords = keywords
        this.handleSearch(keywords)
      },
      immediate: true,
    },
  },
  methods: {
    // 处理日期格式
    handlerDateFormat(list) {
      list.forEach(item => {
        // 处理时间格式，覆盖原始接口返回的参数
        item.publishTime = timeStandrd.timeStandrd(item.createTime)
      })
      return list
    },
    // 取消播放
    cancelPlay() {
      this.url = ''
      this.loadingVideo = false
    },
    // 分页
    change() {
      const paginationRef = this.$refs.pagination
      this.pageNum = paginationRef.currentPage || 10
      this.pageSize = paginationRef.pageSize || 10   
    },
    handleSearch(val) {
      this.searchValue = val
      this.requestLeftResult()
    },
    async requestLeftResult() {
      const params = {
        searchValue: this.searchValue,
        ...this.searchParams
      }
      try {
        this.loading = true
        const { code, data } = await getSearchResult(params)
        let listData = []
        if (code === 200) {
          Object.keys(data).forEach(item => {
            switch (item) {
              case 'InformationManage':
                this.addKey(data[item], `type`, '新闻资讯')
                break
              case 'talentManages':
                this.addKey(data[item], `type`, '人才信息')
                break
              case 'videos':
                this.handlerDateFormat(data[item])
                this.addKey(data[item], `type`, '知产培训')
                break
              default:
                break
            }
          })
          const { InformationManage = [], talentManages = [], videos = [] } = data
          listData = [...InformationManage, ...talentManages, ...videos]
        }
        if (listData) {
          this.list = listData
          this.total = listData.length
        }
      } catch (error) {
        console.log(error.message)
      } finally {
        this.loading = false
      }
    },
    addKey(arr = [], key, v) {
      arr.length && arr.forEach(item => {
        item[key] = v
      })
    },
    toSearch(v) {
      if (!v) return this.$msg('请输入搜索内容！', { icon: 2 })
      this.$router.push({
        name: 'searchResults',
        query: {
          searchV: v
        }
      })
      this.requestLeftResult()
    },
    toDetail(val) {
      const routerList = { '新闻资讯': 'generalInfoDetails', '人才信息': 'talentDetail' }
      const path = routerList[val.type]
      switch (val.type) {
        case '知产培训':
          this.playVideo(val)
          break
        default:
          this.$router.push({ name: path, query: { id: val.id, } })
          break;
      }
    },
    async playVideo(instance) {
      if (this.account === '游客' || this.account === '') {
        return this.$apiStatusHandler(20, '请登录观看视频资源')
      }
      try {
        this.loadingVideo = true
        const { code, data } = await getVideoInfoDetail(instance.id)
        if (code === 200) {
          await viewsVideInfo(instance.id)
          this.$refs.video.showModal()
          if (data.fileUploadVo) {
            this.url = data.fileUploadVo.url
          }
        }
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loadingVideo = false
      }
    },
  },
  components: {
    Pagination,
    commonBanner,
    Empty,
    VideoPlay
  },
};
</script>